import {
	catchError, filter, Observable, of, tap,
} from 'rxjs';
import { SlLEContext } from '../../global-constants';
import { SlApiService } from '../sl-api.service';
import { SlDataService } from '../sl-data.service';
import { IExperimentsDataResponse } from '../../../../api/private/global.interface';
import { ExperimentNames, ILessonQuitPromptExperimentData } from '../../../../api/public/experiment-api';
import { Service, Container, AuthService } from '../../../../symphony';

@Service()
export class SlExperimentsService {
	private api = Container.take(SlLEContext, SlApiService);

	private data = Container.take(SlLEContext, SlDataService);

	private authService = Container.take('global', AuthService);

	private experimentsList = (): ExperimentNames[] => [] // add experiment names here
		;

	public getExperiments = (): Observable<IExperimentsDataResponse | null> => {
		const userId = this.authService?.getUser()?.id;
		const experimentsHandlers = {
			// [/*experiment name */]: /*experiment handler */
		};

		return this.api.getExperimentsData(userId, this.experimentsList()).pipe(
			filter((res: any) => !!res?.data?.length),
			tap(({ data }) => {
				data.forEach((exp: ILessonQuitPromptExperimentData) => {
					experimentsHandlers[exp.experimentName](exp);
				});
			}),
			catchError(() => of(null)),
		);
	};
}
